/* Séréna — theme.js */
(function () {
  'use strict';

  var money = function (cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v + ' €';
  };

  /* ---------------- Overlay / drawers ---------------- */
  var overlay = document.querySelector('[data-overlay]');
  var openPanels = [];

  function openPanel(el) {
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    openPanels.push(el);
  }
  function closePanels() {
    openPanels.forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    openPanels = [];
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      openPanel(document.querySelector(opener.getAttribute('data-open')));
      return;
    }
    if (e.target.closest('[data-close]') || e.target === overlay) {
      closePanels();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanels();
  });

  /* ---------------- Cart ---------------- */
  var drawerBody = document.querySelector('[data-cart-body]');
  var drawerFoot = document.querySelector('[data-cart-foot]');
  var cartCounts = document.querySelectorAll('[data-cart-count]');

  function renderCart(cart) {
    cartCounts.forEach(function (n) { n.textContent = cart.item_count; });
    if (!drawerBody) return;

    if (!cart.item_count) {
      drawerBody.innerHTML = '<p class="cart-empty">Votre panier est vide.</p>';
      if (drawerFoot) drawerFoot.hidden = true;
      return;
    }
    if (drawerFoot) drawerFoot.hidden = false;

    drawerBody.innerHTML = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') + '" alt="" loading="lazy">'
        : '<span></span>';
      var variant = item.options_with_values
        ? item.options_with_values.map(function (o) { return o.value; }).join(' / ')
        : '';
      return (
        '<div class="cart-line" data-key="' + item.key + '">' +
          img +
          '<div>' +
            '<p class="cart-line__title">' + item.product_title + '</p>' +
            '<p class="cart-line__variant">' + variant + '</p>' +
            '<div class="cart-line__qty">' +
              '<button type="button" data-qty="-1" aria-label="Retirer un article">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button type="button" data-qty="1" aria-label="Ajouter un article">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="text-align:right;font-size:13px">' + money(item.final_line_price) + '</div>' +
        '</div>'
      );
    }).join('');

    var totalEl = document.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function changeLine(key, qty) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  if (drawerBody) {
    drawerBody.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      var line = btn.closest('.cart-line');
      var current = parseInt(line.querySelector('.cart-line__qty span').textContent, 10);
      changeLine(line.getAttribute('data-key'), current + parseInt(btn.getAttribute('data-qty'), 10));
    });
    fetchCart();
  }

  /* Add to cart (product form + quick add) */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!drawerBody) return; // fall back to normal POST
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Ajout en cours…'; }

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          return fetchCart();
        })
        .then(function () {
          openPanel(document.querySelector('[data-cart-drawer]'));
        })
        .catch(function () {})
        .finally(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
        });
    });
  });

  /* ---------------- Product gallery ---------------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var stage = gallery.querySelector('[data-gallery-image]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!stage || !thumbs.length) return;
    var index = 0;

    function show(i) {
      index = (i + thumbs.length) % thumbs.length;
      var t = thumbs[index];
      stage.src = t.getAttribute('data-full');
      stage.alt = t.getAttribute('data-alt') || '';
      thumbs.forEach(function (el) { el.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
    }

    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i); });
    });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });
  });

  /* ---------------- Variant picker ---------------- */
  document.querySelectorAll('[data-variants]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-variant-json]').textContent);
    var idInput = root.querySelector('[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var addBtn = root.querySelector('[data-add-label]');
    var selected = {};

    root.querySelectorAll('[data-option]').forEach(function (btn) {
      if (btn.getAttribute('aria-checked') === 'true') {
        selected[btn.getAttribute('data-option')] = btn.getAttribute('data-value');
      }
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-option]');
      if (!btn) return;
      e.preventDefault();
      var pos = btn.getAttribute('data-option');
      selected[pos] = btn.getAttribute('data-value');

      root.querySelectorAll('[data-option="' + pos + '"]').forEach(function (el) {
        el.setAttribute('aria-checked', el === btn ? 'true' : 'false');
      });
      var out = root.querySelector('[data-option-value="' + pos + '"]');
      if (out) out.textContent = selected[pos];

      var match = data.find(function (v) {
        return Object.keys(selected).every(function (k) {
          return v.options[parseInt(k, 10) - 1] === selected[k];
        });
      });

      if (match) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (addBtn) {
          addBtn.textContent = match.available
            ? 'Ajouter au panier — ' + money(match.price)
            : 'Rupture de stock';
        }
        var submit = root.querySelector('[type="submit"]');
        if (submit) submit.disabled = !match.available;
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url);
        }
      }
    });
  });

  /* ---------------- Scroll reveal ---------------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  }
})();

/* ============================================================
   Séréna — v2 interactions
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Rotating announcement bar ---------- */
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var msgs = Array.prototype.slice.call(bar.querySelectorAll('.announcement__msg'));
    if (msgs.length < 2) return;

    var index = 0;
    var delay = parseInt(bar.getAttribute('data-interval'), 10) || 4000;
    var timer;

    function go(next) {
      var current = msgs[index];
      current.classList.remove('is-active');
      current.classList.add('is-out');
      setTimeout(function () { current.classList.remove('is-out'); }, 500);

      index = (next + msgs.length) % msgs.length;
      msgs[index].classList.add('is-active');
    }

    function start() {
      stop();
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { go(index + 1); }, delay);
    }
    function stop() { if (timer) clearInterval(timer); }

    var prev = bar.querySelector('[data-announcement-prev]');
    var next = bar.querySelector('[data-announcement-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1); start(); });

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () {
      document.hidden ? stop() : start();
    });
    start();
  });

  /* ---------- Header shadow once scrolled ---------- */
  var header = document.querySelector('.header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Sticky add-to-cart ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var mainForm = document.querySelector('.product__info form[data-product-form]');
  if (sticky && mainForm) {
    var addBtn = sticky.querySelector('[data-sticky-add]');
    var stickyPrice = sticky.querySelector('[data-sticky-price]');

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        if (typeof mainForm.requestSubmit === 'function') {
          mainForm.requestSubmit();
        } else {
          mainForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    }

    // Mirror the live price from the main variant picker
    var priceEl = document.querySelector('[data-price]');
    if (priceEl && stickyPrice && 'MutationObserver' in window) {
      new MutationObserver(function () {
        stickyPrice.textContent = priceEl.textContent;
      }).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          // Show the bar once the real button has scrolled out of view
          sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(mainForm);
    }
  }

  /* ---------- Marquee: pause when off-screen ---------- */
  if ('IntersectionObserver' in window) {
    var mo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var track = entry.target.querySelector('.marquee__track');
        if (track) track.style.animationPlayState = entry.isIntersecting ? 'running' : 'paused';
      });
    }, { threshold: 0 });
    document.querySelectorAll('.marquee').forEach(function (m) { mo.observe(m); });
  }
})();

/* ============================================================
   Séréna — review list
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-reviews-app]');
  if (!root) return;

  var STAR = '<svg viewBox="0 0 24 24"><path d="m12 3 2.7 5.8 6.3.8-4.6 4.4 1.2 6.3L12 17.3 6.4 20.3l1.2-6.3L3 9.6l6.3-.8z"/></svg>';
  var CHECK = '<svg class="ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m4.5 12.5 5 5L20 6.5"/></svg>';

  var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 6;
  var listEl = root.querySelector('[data-rv-list]');
  var pagEl = root.querySelector('[data-rv-pagination]');
  var resultsEl = root.querySelector('[data-rv-results]');
  var sortEl = root.querySelector('[data-rv-sort]');
  var searchEl = root.querySelector('[data-rv-search]');
  var filterEl = root.querySelector('[data-rv-filter]');
  var distEl = root.querySelector('[data-rv-dist]');

  var all = [];
  var view = [];
  var page = 1;
  var voted = {};

  function stars(n) {
    return '<span class="stars">' + STAR.repeat(n) + '</span>';
  }

  function ago(iso) {
    var then = new Date(iso + 'T00:00:00');
    var days = Math.max(0, Math.round((Date.now() - then.getTime()) / 86400000));
    if (days === 0) return "aujourd'hui";
    if (days === 1) return 'hier';
    if (days < 30) return 'il y a ' + days + ' jours';
    var months = Math.round(days / 30);
    if (months < 12) return 'il y a ' + months + ' mois';
    var years = Math.floor(months / 12);
    return years === 1 ? 'il y a 1 an' : 'il y a ' + years + ' ans';
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function apply() {
    var term = (searchEl.value || '').trim().toLowerCase();
    var min = parseInt(filterEl.value, 10) || 0;

    view = all.filter(function (r) {
      if (min && r.r !== min) return false;
      if (!term) return true;
      return (r.t + ' ' + r.b + ' ' + r.n).toLowerCase().indexOf(term) > -1;
    });

    var mode = sortEl.value;
    view.sort(function (a, b) {
      if (mode === 'recent') return a.d < b.d ? 1 : -1;
      if (mode === 'old') return a.d > b.d ? 1 : -1;
      if (mode === 'best') return b.r - a.r || (a.d < b.d ? 1 : -1);
      if (mode === 'worst') return a.r - b.r || (a.d < b.d ? 1 : -1);
      if (mode === 'helpful') return b.h - a.h;
      return 0;
    });

    page = 1;
    render();
  }

  function render() {
    var pages = Math.max(1, Math.ceil(view.length / perPage));
    if (page > pages) page = pages;
    var slice = view.slice((page - 1) * perPage, page * perPage);

    resultsEl.textContent = view.length
      ? view.length.toLocaleString('fr-FR') + ' avis'
      : '';

    if (!slice.length) {
      listEl.innerHTML = '<p class="rv__empty">Aucun avis ne correspond à votre recherche.</p>';
      pagEl.innerHTML = '';
      return;
    }

    listEl.innerHTML = slice.map(function (r) {
      var helped = voted[r.i] ? r.h + 1 : r.h;
      return (
        '<article class="rv__item">' +
          '<div class="rv__who">' +
            (r.v ? '<span class="rv__verified">' + CHECK + ' Cliente vérifiée</span>' : '') +
            '<p class="rv__name">' + escapeHtml(r.n) + '</p>' +
            '<p class="rv__variant">' + escapeHtml(r.o) + '</p>' +
          '</div>' +
          '<div class="rv__body">' +
            stars(r.r) +
            '<h4>' + escapeHtml(r.t) + '</h4>' +
            '<p>' + escapeHtml(r.b) + '</p>' +
            '<div class="rv__foot">' +
              '<span class="rv__helpful">Cet avis vous a-t-il été utile ?' +
                '<button type="button" data-vote="' + r.i + '"' + (voted[r.i] ? ' disabled' : '') + '>Oui</button>' +
                '<span>(' + helped + ')</span>' +
              '</span>' +
              '<span class="rv__date">' + ago(r.d) + '</span>' +
            '</div>' +
          '</div>' +
        '</article>'
      );
    }).join('');

    // Pagination: 1 2 3 … last, windowed around the current page
    var nums = [];
    for (var i = 1; i <= pages; i++) {
      if (i <= 2 || i > pages - 1 || Math.abs(i - page) <= 1) nums.push(i);
      else if (nums[nums.length - 1] !== '…') nums.push('…');
    }
    pagEl.innerHTML = nums.map(function (n) {
      if (n === '…') return '<span>…</span>';
      return '<button type="button" data-page="' + n + '" aria-current="' + (n === page) + '">' +
        n.toLocaleString('fr-FR') + '</button>';
    }).join('');
  }

  function boot(data) {
    all = data.reviews.slice();

    root.querySelector('[data-rv-average]').textContent =
      data.meta.average.toFixed(1).replace('.', ',');
    root.querySelector('[data-rv-total]').textContent =
      data.meta.total.toLocaleString('fr-FR');

    var notice = root.querySelector('[data-sample-notice]');
    if (notice && data.meta.sample) notice.hidden = false;

    if (distEl) {
      distEl.innerHTML = [5, 4, 3, 2, 1].map(function (n) {
        var count = data.meta.distribution[n] || 0;
        var pct = Math.round((count / data.meta.total) * 100);
        return '<div class="rv__dist-row"><span>' + n + ' ★</span>' +
          '<span class="rv__bar"><span style="width:' + pct + '%"></span></span>' +
          '<span>' + pct + '%</span></div>';
      }).join('');
    }

    apply();
  }

  function waitForData(tries) {
    if (window.SERENA_REVIEWS) return boot(window.SERENA_REVIEWS);
    if (tries <= 0) {
      listEl.innerHTML = '<p class="rv__empty">Les avis n\'ont pas pu être chargés.</p>';
      return;
    }
    setTimeout(function () { waitForData(tries - 1); }, 120);
  }

  [sortEl, filterEl].forEach(function (el) { el.addEventListener('change', apply); });

  var debounce;
  searchEl.addEventListener('input', function () {
    clearTimeout(debounce);
    debounce = setTimeout(apply, 220);
  });

  pagEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-page]');
    if (!btn) return;
    page = parseInt(btn.getAttribute('data-page'), 10);
    render();
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  listEl.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-vote]');
    if (!btn) return;
    voted[btn.getAttribute('data-vote')] = true;
    render();
  });

  waitForData(60);
})();

/* ============================================================
   Séréna — carousels (Trustpilot + UGC)
   ============================================================ */
(function () {
  'use strict';

  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.carousel__track');
    var prev = carousel.querySelector('[data-carousel-prev]');
    var next = carousel.querySelector('[data-carousel-next]');
    if (!track) return;

    function step() {
      var first = track.firstElementChild;
      return first ? first.getBoundingClientRect().width + 16 : 260;
    }
    function sync() {
      if (prev) prev.disabled = track.scrollLeft < 8;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();
